/**
 * Identité de l'éditeur — source unique.
 *
 * RELOAD est exploité par BINAIRE SAS : tout ce qui sort de l'application
 * (interface, PDF, emails, page publique) porte cette identité. Les valeurs
 * ci-dessous sont reprises du dossier commercial de référence de BINAIRE, afin
 * qu'une proposition envoyée depuis RELOAD et un devis rédigé à la main se
 * ressemblent. Le pendant côté serveur est `backend/src/config/brand.js`.
 */

/** Le produit garde son nom ; BINAIRE SAS apparaît comme éditeur. */
export const PRODUCT = {
  name: 'RELOAD',
  suffix: 'V2',
  tagline: 'Analyse, audit, refonte web, pitch commercial et devis.',
};

export const PUBLISHER = {
  name: 'BINAIRE SAS',
  capital: 'SAS au capital de 2 000 000 F',
  rccm: 'GA-LBV-01-2025-B16-00037',
  nif: '2025 0101 1058 F',
  address: 'Libreville, Louis',
  country: 'Gabon',
  phone: '+241 074 143 801',
  email: 'contact@binaire.tech',
  website: 'https://binaire.tech',
  websiteLabel: 'binaire.tech',
};

/**
 * Charte BINAIRE. Ces couleurs habillent l'application et les documents en tant
 * qu'émetteur : elles ne remplacent jamais la couleur de marque du client, qui
 * reste celle de son audit et de sa proposition.
 */
export const BRAND_COLORS = {
  navy: '#1F3864',
  blue: '#0D6EB4',
  blueSoft: '#2E74B5',
  gold: '#BF8F00',
  grey: '#5A5A5A',
  light: '#DEEAF6',
  cream: '#FDF5E6',
  dark: '#232323',
};

/** Fichier servi à la racine, pour l'interface (le PDF utilise `brand/logo.js`). */
export const PUBLISHER_LOGO_URL = '/binaire-logo.png';

/** « BINAIRE SAS au capital de 2 000 000 F | N° RCCM : … | N° NIF : … | Libreville, Louis » */
export function legalLine(separator = '  |  ') {
  return [
    `${PUBLISHER.name} au capital de 2 000 000 F`,
    `N° RCCM : ${PUBLISHER.rccm}`,
    `N° NIF : ${PUBLISHER.nif}`,
    PUBLISHER.address,
  ].join(separator);
}

/** « +241 074 143 801 | contact@binaire.tech | binaire.tech » */
export function contactLine(separator = '  |  ') {
  return [PUBLISHER.phone, PUBLISHER.email, PUBLISHER.websiteLabel].join(separator);
}

export default { PRODUCT, PUBLISHER, BRAND_COLORS, PUBLISHER_LOGO_URL, legalLine, contactLine };
